// Generated by CoffeeScript 1.11.1
(function() {
  var Descriptor, LayerInfo, VectorStrokeContent,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  Descriptor = require('../descriptor');

  module.exports = VectorStrokeContent = (function(superClass) {
    extend(VectorStrokeContent, superClass);

    function VectorStrokeContent() {
      return VectorStrokeContent.__super__.constructor.apply(this, arguments);
    }

    VectorStrokeContent.shouldParse = function(key) {
      return key === 'vscg';
    };

    VectorStrokeContent.prototype.parse = function() {
      this.file.seek(8, true);
      return this.data = new Descriptor(this.file).parse();
    };

    return VectorStrokeContent;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/vector_stroke_content.js
// module id = 81
// module chunks = 0